import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage, RecoveryPasswordPage } from "../auth/pages";
import { PrivateRouter } from "./PrivateRouter";
import { AdminRouter } from "../admin/routes/AdminRouter";
import { PublicRouter } from "./PublicRouter";
import { useDispatch } from "react-redux";
import { login } from "../store/auth";

export const AppRouter = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("x-token");

  if (token) {
    dispatch(login(token));
  }
  return (
    <Routes>
      <Route
        path="admin/*"
        element={
          <PrivateRouter>
            <AdminRouter />
          </PrivateRouter>
        }
      />
      <Route
        path="auth/*"
        element={
          <PublicRouter>
            <Routes>
              <Route path="" element={<LoginPage />}></Route>
              <Route
                path="/recovery-pass"
                element={<RecoveryPasswordPage />}
              ></Route>
            </Routes>
          </PublicRouter>
        }
      ></Route>
      <Route path="/*" element={<Navigate to="/auth" />} />
    </Routes>
  );
};
